import banner from '../../../assets/industries/travel.webp'

import tick from '../../../assets/industries/tick.webp'


export const bannerData = {
    title1: 'Travel and Tourism',
    title2: 'Software Development',
    desc: 'Partner with a trusted custom software development company to digitize your travel and tourism business.',
    img: banner,
    btnTitle: 'Hire Software Developers'
}

export const hireData = {
    img: tick,
    title: ' Outsource Tourism and Travel App',
    points: [
        'Competence in custom on demand app development services',
        'Flexible engagement models',
        'UI/UX optimized development',
        'Instant chat support',
        'Diverse technology stack',
        'Data privacy protection'

    ]
}

export const webDesignData = {
    title1: 'Custom Travel and Tourism',
    title2: 'Development Services',
    cards: [
        {
            title: 'E-booking and Ticketing Systems',
            desc: 'Provide interactive booking and ticketing experience for your customers by building apps with the latest technologies i.e. AI and cloud computing. Codezone can help you build all types of e-booking and ticketing systems.',
        },
        {
            title: 'Travel Mobility Solutions',
            desc: 'Build next-generation tourism and hospitality apps especially for hotels and restaurants. Our developers are experts in building tourism apps including Customer service kiosks, payment gateways, seat booking, and food ordering apps.',
        },
        {
            title: 'Transportation Information App',
            desc: 'Empower users with real-time transportation information apps. We help you develop cross-platform mobile software with user-friendly interfaces and custom-built features.',
        },
        {
            title: 'AR and VR based Travel Apps',
            desc: 'Assist users in defining their travel destinations by unlocking the power of augmented and virtual reality-based apps. Build AR/VR apps like AR based travel planning and guide apps, Travel management solutions, virtual tours apps, and AR-based GPS apps..',
        },
    ]
}